import { combineReducers } from 'redux';
import { AppReducer } from './app/reducer';
import { SessionReducer } from './session/reducer';
import { MapReducer } from './map/reducer';
import { TeamReducer } from './team/reducer';
import { OrganisationReducer } from './organisation/reducer';
import { SiteReducer } from './site/reducer';
import { AnnouncementReducer } from './announcement/reducer';
import {
  AppState,
  SessionState,
  MapState,
  TeamState,
  OrganisationState,
  AnnouncementState,
  SiteState
} from 'types';

export interface RootState {
  app: AppState;
  session: SessionState;
  mapCache: MapState;
  teamCache: TeamState;
  organisationCache: OrganisationState;
  announcementCache: AnnouncementState;
  siteCache: SiteState;
}

const rootReducer = combineReducers<RootState>({
  app: AppReducer,
  mapCache: MapReducer,
  session: SessionReducer,
  teamCache: TeamReducer,
  organisationCache: OrganisationReducer,
  announcementCache: AnnouncementReducer,
  siteCache: SiteReducer
});

export default rootReducer;
